import React, { useState } from 'react';
import './EventCard.scss';
import { Col, Row } from 'antd';
import { EEventCategory, ICorrection, IMeetingSession } from '../../interfaces/event';
import { instanceOfMeeting, isEventDisabled, isEventLive } from '../../helpers';

interface IProps {
  dataId: string;
  event: IMeetingSession | ICorrection;
  isOverdue?: boolean;
  onClick?: () => void;
}

export const EventCard = (props: IProps) => {
  const { dataId, event, isOverdue = false, onClick } = props;

  const [showTooltip, setShowTooltip] = useState(false);

  const getEventTypeClass = () => {
    if (instanceOfMeeting(event)) {
      switch (event.category) {
        case EEventCategory.Meeting:
          return 'meeting';
        case EEventCategory.OpenSession:
          return 'session';
      }
    } else {
      return 'correction';
    }
  };

  const getEventTypeLabel = () => {
    if (instanceOfMeeting(event)) {
      switch (event.category) {
        case EEventCategory.Meeting:
          return 'Meeting';
        case EEventCategory.OpenSession:
          return 'Session';
      }
    } else {
      return 'Correction';
    }
  };

  const handleMouseEnter = () => {
    const titleElement = document.getElementById(dataId);
    if (!titleElement) {
      return;
    }

    if (!isDisabled && titleElement.offsetWidth < titleElement.scrollWidth) {
      setShowTooltip(true);
    }
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const isDisabled = isEventDisabled(isOverdue, event.end);
  const isLive = isEventLive(event.start, event.end);

  return (
    <Row
      onClick={onClick}
      className={`eventCard-container ${isDisabled && 'disabled'} ${!isDisabled && !isOverdue && isLive && 'live'} ${isOverdue && 'overdue'}`}>
      <Col span={17}>
        <div
          id={dataId}
          data-value={event.summary}
          className={`eventCard-title  ${isDisabled && 'disabled'}`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}>
          {event.summary}
          {showTooltip && <span className="tooltiptext">{event.summary}</span>}
        </div>
        <div className={`eventCard-type ${getEventTypeClass()}`}>{getEventTypeLabel()}</div>
      </Col>
      <Col span={4}>{!isDisabled && !isOverdue && isLive && <div className="eventCard-liveFlag">Live</div>}</Col>
      {isOverdue ? (
        <Col span={3}>
          <div className="eventCard-overdueFlag">Overdue</div>
        </Col>
      ) : (
        <Col span={3}>
          <div className={`eventCard-startTime ${isDisabled && 'disabled'}`}>{new Date(event.start).toLocaleTimeString().substring(0, 5)}</div>
          <div className="eventCard-endTime">{new Date(event.end).toLocaleTimeString().substring(0, 5)}</div>
        </Col>
      )}
    </Row>
  );
};
